import { AxiosError, AxiosResponse } from 'axios'
import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { fetchAPI } from '@/lib/api'
import { useErrorHandler } from '@/lib/hooks'
import { getPathParams } from '@/lib/routes'

import { TOAST_CONFIG } from '@/lib/constants'
import { DIALOG, PROJECT } from '../../constants'

import { PageSettingFormInput } from '../types'

type Payload = {
  data: PageSettingFormInput
  params: {
    projectId: number
  }
}

const updateBannerDisplay = async ({ data, params }: Payload) => {
  const { projectId } = params

  return await fetchAPI({
    path: `/projects/${projectId}/dialogs`,
    method: 'put',
    data,
  })
}

export const useUpdateBannerDisplay = () => {
  const toast = useToast()
  const handleError = useErrorHandler()
  const queryClient = useQueryClient()
  const { t } = useTranslation('domains')

  const query = getPathParams()
  const params = { project_id: Number(query?.project_id) }

  return useMutation<AxiosResponse, AxiosError<RailsError>, Payload>(
    updateBannerDisplay,
    {
      onSuccess() {
        queryClient.invalidateQueries([DIALOG, params])
        queryClient.invalidateQueries([PROJECT, params])

        toast({
          ...TOAST_CONFIG,
          description: t('bannerSettings.toast.updateBannerDisplaySuccess'),
        })
      },
      onError(error) {
        handleError(error)
      },
    },
  )
}
